import get from 'lodash/get';

class InteractiveBorder {
    constructor(data) {
        this.width = get(data, 'width', 1);
        this.color = get(data, 'color', 'rgba(255,255,255,1)');
    }
}

export default InteractiveBorder;